export default __webpack_public_path__ + "static/media/image-banner-w@2x.6cc389d1.png";